// TODO: remove this and use styled-system directly instead.
// This is just part of the migration which allows DD to import toolkit components.
export { defaultTheme as theme, withOpacity } from 'styled-system';
